import { OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/security/auth.service';
import { EventParamDTO } from 'app/header-footer-template/model/EventParamDTO';
import { EventService } from 'app/services/event-service';
import { CommonsText } from 'app/commons/CommonsText';
var ExpedientesPageComponent = /** @class */ (function () {
    function ExpedientesPageComponent(router, route, authService, eventService, toastr) {
        this.router = router;
        this.route = route;
        this.authService = authService;
        this.eventService = eventService;
        this.toastr = toastr;
        this.loading = false;
        this.cards = [];
        // Solo el área directa (ONLYGAL) abre expedientes desde aquí: para reaseguro el alta ni
        // se ofrece, y de hecho el guard de rutas ya bloquea /events/register en ese caso.
        this.showDirectAreas = true;
        this.params = new EventParamDTO();
        this.filtersCollapsed = true;
        // Ambos desplegables se rellenan con los listados que devuelve el servicio (product y
        // statusType), que vienen calculados sobre todos los expedientes visibles del usuario, sin
        // los filtros de pantalla y sin paginar.
        this.seguros = [{ value: '', ids: [], label: 'Todos los seguros' }];
        this.estados = [{ value: '', ids: [], label: 'Todos los estados' }];
        // Numeros de expediente del usuario, que el servicio devuelve en eventItems (tambien
        // calculados antes de filtrar y paginar). Alimentan el multiselect, igual que en el filtro de
        // la pagina de historico.
        this.expedientesList = [];
        this.expedientesSeleccionados = [];
        this.expedientesSettings = {};
        // Mensaje del control de coherencia entre las dos fechas.
        this.fechaError = '';
        this.selectedSeguro = '';
        this.selectedEstado = '';
        this.fechaDesde = '';
        this.fechaHasta = '';
        // Poliza por la que llega filtrado el listado desde la URL (?policy=). No tiene campo en el
        // panel de filtros: se muestra como una chip que permite quitarlo.
        this.polizaFiltro = null;
    }
    ExpedientesPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.showDirectAreas = this.authService.getSelectedEntity() === 'ONLYGAL';
        this.params.pageOffset = 0;
        this.params.pageSize = 12;
        this.params.statusType = [];
        this.params.product = [];
        this.params.eventItems = [];
        // Mismos ajustes que el multiselect de partes de event-filter, para que se comporte igual
        // (buscador interno, sin "seleccionar todo" y sin boton de limpiar).
        this.expedientesSettings = {
            singleSelection: false,
            text: 'Todos los expedientes',
            enableCheckAll: false,
            enableSearchFilter: true,
            enableFilterSelectAll: false,
            searchPlaceholderText: 'Nº expediente',
            classes: 'multi-select',
            clearAll: false,
            // La libreria si lee maxHeight (al contrario que tagToBody), asi que el alto del panel
            // se limita por ajuste y no por CSS.
            maxHeight: 220,
            // Sin chips. La plantilla de la libreria oculta cada una con
            // [hidden]="k > settings.badgeShowLimit-1", asi que con 0 no se pinta ninguna;
            // badgeShowLimit si lo lee de verdad, al contrario que tagToBody. Se quitan porque
            // eran lo unico que hacia crecer el campo de alto: al no caber en la linea se
            // apilaban y el tercer filtro dejaba de estar alineado con los dos de al lado (con
            // 29 expedientes, que es lo que tiene un usuario real, pasaba de 50 a casi 300px).
            // Lo seleccionado se resume en texto en la plantilla.
            badgeShowLimit: 0
        };
        // Filtro fijo: el listado solo muestra los expedientes de polizas en las que el
        // usuario es tomador. No es un filtro de pantalla, no se expone en el formulario.
        //this.params.isTaker = true;
        // La busqueda inicial la lanza la primera emision. Se escucha queryParamMap y no el
        // snapshot porque Angular reutiliza el componente al navegar a /expedientes con otros
        // parametros (por ejemplo al quitar la chip de poliza), y entonces ngOnInit no se repite.
        this.queryParamsSub = this.route.queryParamMap.subscribe(function (query) {
            _this.polizaFiltro = _this.toPolicyNumber(query.get(ExpedientesPageComponent.POLICY_QUERY_PARAM));
            _this.params.policyNumber = _this.polizaFiltro;
            _this.params.pageOffset = 0;
            _this.search();
        });
    };
    ExpedientesPageComponent.prototype.ngOnDestroy = function () {
        if (this.queryParamsSub) {
            this.queryParamsSub.unsubscribe();
        }
    };
    /**
     * El backend recibe el numero de poliza como Long (SearchDTO.policyNumber): cualquier valor
     * que no sean solo digitos devolveria 400, asi que se descarta y se lista sin filtrar.
     */
    ExpedientesPageComponent.prototype.toPolicyNumber = function (valor) {
        var limpio = (valor || '').trim();
        return /^\d+$/.test(limpio) ? limpio : null;
    };
    /**
     * Quita el filtro de poliza navegando a la misma ruta sin el parametro, para que la URL y el
     * listado no se contradigan; la suscripcion a queryParamMap relanza la busqueda.
     */
    ExpedientesPageComponent.prototype.quitarFiltroPoliza = function () {
        this.router.navigate(['/expedientes']);
    };
    ExpedientesPageComponent.prototype.aplicarFiltros = function () {
        // Estado y seguro los resuelve el backend sobre todos los expedientes del usuario, no
        // sobre las tarjetas de la pagina actual: aqui solo se traduce la seleccion a la forma que
        // espera el servicio. Se vuelve a la primera pagina porque al filtrar cambia el total y el
        // offset anterior puede quedarse fuera del nuevo resultado.
        if (!this.rangoFechasValido()) {
            return;
        }
        this.params.statusType = this.toParamItems(this.estados, this.selectedEstado);
        this.params.product = this.toParamItems(this.seguros, this.selectedSeguro);
        this.params.eventItems = this.expedientesSeleccionados || [];
        this.params.pageOffset = 0;
        // El filtro de poliza que llega por la URL se mantiene hasta que se quita su chip.
        this.params.policyNumber = this.polizaFiltro;
        this.params.startDate = this.toBackendDate(this.fechaDesde);
        this.params.endDate = this.toBackendDate(this.fechaHasta);
        this.search();
    };
    /**
     * El equivalente a comprobarDesde/comprobarHasta de event-filter: alli son validadores del
     * formulario reactivo, y aqui el panel trabaja con ngModel suelto, asi que la coherencia se
     * comprueba al aplicar. Las fechas vienen del input nativo en formato ISO (yyyy-MM-dd), que
     * se ordena igual alfabeticamente que cronologicamente, de ahi la comparacion directa.
     */
    ExpedientesPageComponent.prototype.rangoFechasValido = function () {
        if (this.fechaDesde && this.fechaHasta && this.fechaDesde > this.fechaHasta) {
            this.fechaError = 'La fecha "desde" no puede ser posterior a la fecha "hasta".';
            return false;
        }
        this.fechaError = '';
        return true;
    };
    /**
     * El input nativo de tipo date entrega yyyy-MM-dd, pero SearchDTO declara las fechas con
     * pattern "dd-MM-yyyy" (que tiene prioridad sobre el iso de la misma anotacion), asi que
     * mandarlas como las da el navegador devuelve 400 y el filtro de fechas no llegaba a aplicarse.
     */
    ExpedientesPageComponent.prototype.toBackendDate = function (iso) {
        if (!iso) {
            return null;
        }
        var partes = iso.split('-');
        if (partes.length !== 3) {
            return null;
        }
        return partes[2] + '-' + partes[1] + '-' + partes[0];
    };
    /**
     * Traduce la opcion elegida a lo que serializa event-service: un array de objetos con id, del
     * que se manda un parametro por elemento. "Todos" devuelve un array vacio, que deja el filtro
     * sin informar y llega al backend como null (su forma de decir "sin filtrar"); mandar el
     * conjunto vacio no valdria, porque alli se comprueba con contains() y vaciaria el listado.
     */
    ExpedientesPageComponent.prototype.toParamItems = function (opciones, valor) {
        var elegida = opciones.filter(function (o) { return o.value === valor; })[0];
        if (!elegida || elegida.ids.length === 0) {
            return [];
        }
        return elegida.ids.map(function (id) { return ({ id: id }); });
    };
    Object.defineProperty(ExpedientesPageComponent.prototype, "resumenExpedientes", {
        /**
         * Lo que se pinta sobre el campo cerrado en lugar de las chips de la libreria. Con un solo
         * expediente se enseña su numero, que es justo lo que el usuario estaba buscando; a partir de
         * dos solo cabe el recuento, porque el campo mide una linea y el usuario puede tener decenas
         * (29 en el caso que destapo el problema). Que expedientes concretos estan marcados se
         * consulta abriendo el desplegable, que ademas lleva buscador.
         */
        get: function () {
            var elegidos = this.expedientesSeleccionados || [];
            if (elegidos.length === 0) {
                return '';
            }
            if (elegidos.length === 1) {
                var uno = elegidos[0] || {};
                // itemName es la etiqueta por defecto de la libreria (no se informa labelKey).
                return 'Expediente ' + (uno.itemName || uno.id || '');
            }
            return elegidos.length + ' expedientes seleccionados';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Deshacer la seleccion desde el desplegable serian tantos clics como expedientes marcados,
     * asi que el campo ofrece un aspa para vaciarlo de una vez. Solo cambia lo que se ve: la
     * busqueda no se relanza hasta que se pulsa "Aplicar filtros", igual que al cambiar
     * cualquiera de los dos desplegables de al lado.
     */
    ExpedientesPageComponent.prototype.limpiarExpedientes = function (evento) {
        // Sin esto el clic llegaria al boton de la libreria y abriria el desplegable.
        evento.stopPropagation();
        this.expedientesSeleccionados = [];
    };
    ExpedientesPageComponent.prototype.toggleFilters = function () {
        this.filtersCollapsed = !this.filtersCollapsed;
    };
    ExpedientesPageComponent.prototype.irNuevoExpediente = function () {
        this.router.navigate(['/events/register']);
    };
    /**
     * El detalle y la mensajeria del expediente solo se ofrecen cuando el asegurado del
     * expediente es el propio usuario logado. El listado puede traer partes de polizas en las que
     * el usuario es tomador pero el asegurado es otra persona (un hijo, un empleado...), y en ese
     * caso no debe poder entrar al detalle ni escribir al tramitador.
     *
     * Ante la duda (dato ausente) se oculta: es preferible que un tomador legitimo tenga que
     * llamar a que alguien vea un expediente de otra persona.
     */
    ExpedientesPageComponent.prototype.puedeOperar = function (card) {
        return !!card && card.esAseguradoEnExpediente === true;
    };
    ExpedientesPageComponent.prototype.irDetalle = function (card) {
        if (!this.puedeOperar(card)) {
            return;
        }
        var ruta = this.eventRoute(card);
        if (ruta) {
            this.router.navigate(ruta);
        }
    };
    ExpedientesPageComponent.prototype.irMensajeria = function (card) {
        if (!this.puedeOperar(card)) {
            return;
        }
        var ruta = this.eventRoute(card);
        if (ruta) {
            this.router.navigate(ruta.concat(['messenger']));
        }
    };
    ExpedientesPageComponent.prototype.eventRoute = function (card) {
        var ref = (card && card.expedienteNumero || '').toString().trim();
        if (!ref) {
            return null;
        }
        return ['/event', ref];
    };
    ExpedientesPageComponent.prototype.irChat = function () {
        this.router.navigate(['/contact/form']);
    };
    Object.defineProperty(ExpedientesPageComponent.prototype, "visibleCards", {
        /**
         * Ya no queda ningun filtro de pantalla: estado, seguro y numero de expediente los aplica el
         * backend sobre todos los expedientes del usuario, porque filtrando aqui solo se miraban las
         * tarjetas de la pagina actual. Se mantiene la propiedad para no tocar la plantilla.
         */
        get: function () {
            return this.cards;
        },
        enumerable: true,
        configurable: true
    });
    ExpedientesPageComponent.prototype.search = function () {
        var _this = this;
        this.loading = true;
        this.eventService.search(this.params)
            .then(function (success) {
            _this.loading = false;
            _this.response = success;
            _this.cards = _this.toCards(success);
            _this.refreshFilters(success);
        })
            .catch(function () {
            _this.loading = false;
            _this.response = null;
            _this.cards = [];
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_PARTES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, { timeOut: 5000 });
        });
    };
    ExpedientesPageComponent.prototype.toCards = function (resp) {
        var _this = this;
        var content = (resp && resp.content) ? resp.content : [];
        return content.map(function (item) {
            var estadoRaw = (item.eventStatus || '').toString();
            var estadoSlug = _this.estadoToSlug(estadoRaw);
            return {
                motivo: item.versionType || '',
                producto: item.policyProduct || '',
                polizaNumero: (item.policyNumber || item.idRea || '').toString(),
                expedienteNumero: (item.eventNumber || '').toString(),
                eventYear: (item.eventYear || '').toString(),
                fechaOcurrencia: _this.formatDay(item.eventEndDate || item.eventDate),
                estadoRaw: estadoRaw,
                estadoLabel: _this.estadoToLabel(estadoSlug, estadoRaw),
                estadoSlug: estadoSlug,
                // Se compara estrictamente con true: si el backend no mandase el dato (undefined)
                // no se puede afirmar que el asegurado sea el usuario, y se oculta.
                esAseguradoEnExpediente: item.isInsuredInEvent === true
            };
        });
    };
    Object.defineProperty(ExpedientesPageComponent.prototype, "currentPage", {
        get: function () {
            return this.response ? this.response.number + 1 : 1;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Numeros a pintar en el paginado. Con mas de 7 paginas se recorta alrededor de la actual y
     * se marcan los saltos con null, que la plantilla dibuja como puntos suspensivos. Misma
     * logica que el listado de recibos.
     */
    ExpedientesPageComponent.prototype.getPages = function () {
        if (!this.response || !this.response.totalPages) {
            return [];
        }
        var total = this.response.totalPages;
        var current = this.currentPage;
        if (total <= 7) {
            return Array.from({ length: total }, function (_, i) { return i + 1; });
        }
        var start = Math.max(1, current - 2);
        var end = Math.min(total, current + 2);
        if (end - start < 4) {
            if (start === 1) {
                end = Math.min(total, 5);
            }
            else {
                start = Math.max(1, end - 4);
            }
        }
        var pages = [];
        if (start > 1) {
            pages.push(1);
            if (start > 2) {
                pages.push(null);
            }
        }
        for (var i = start; i <= end; i++) {
            pages.push(i);
        }
        if (end < total) {
            if (end < total - 1) {
                pages.push(null);
            }
            pages.push(total);
        }
        return pages;
    };
    ExpedientesPageComponent.prototype.prev = function () {
        if (!this.loading && this.response && !this.response.first) {
            this.irAPagina(this.response.number - 1);
        }
    };
    ExpedientesPageComponent.prototype.next = function () {
        if (!this.loading && this.response && !this.response.last) {
            this.irAPagina(this.response.number + 1);
        }
    };
    ExpedientesPageComponent.prototype.goToPage = function (p) {
        if (!this.loading) {
            this.irAPagina(p - 1);
        }
    };
    /**
     * A diferencia de recibos, que pasa por su servicio, aqui la pagina es un parametro mas de
     * la busqueda: se fija el offset y se vuelve a pedir.
     */
    ExpedientesPageComponent.prototype.irAPagina = function (offset) {
        this.params.pageOffset = offset;
        this.search();
    };
    ExpedientesPageComponent.prototype.refreshFilters = function (resp) {
        this.seguros = this.toOptions(resp && resp.product, 'Todos los seguros');
        this.estados = this.toOptions(resp && resp.statusType, 'Todos los estados');
        // El listado de expedientes solo se refresca cuando viene informado: al filtrar por uno
        // concreto el servicio los sigue devolviendo todos, pero si alguna respuesta no lo trajera
        // se conserva el ultimo bueno en vez de dejar el multiselect vacio y sin poder deshacer.
        var items = (resp && resp.eventItems) ? resp.eventItems : [];
        if (items.length > 0) {
            this.expedientesList = items;
        }
        // Las opciones se rehacen en cada busqueda, pero el servicio las calcula antes de aplicar
        // los filtros, asi que son siempre las mismas y la seleccion del usuario se conserva. Si
        // aun asi desapareciera, se vuelve a "Todos" para no dejar el desplegable en blanco; se
        // limpia tambien el parametro para que lo que se ve y lo que se pide no se contradigan.
        if (!this.existeOpcion(this.seguros, this.selectedSeguro)) {
            this.selectedSeguro = '';
            this.params.product = [];
        }
        if (!this.existeOpcion(this.estados, this.selectedEstado)) {
            this.selectedEstado = '';
            this.params.statusType = [];
        }
    };
    ExpedientesPageComponent.prototype.existeOpcion = function (opciones, valor) {
        return opciones.some(function (o) { return o.value === valor; });
    };
    /**
     * Convierte un listado del servicio ({id, itemName}) en opciones del desplegable: el codigo
     * como valor y la descripcion como etiqueta. El valor tiene que ser el codigo porque ahora
     * filtra el backend, y alli se compara contra el codigo crudo del parte (eventStatus /
     * policyProductId), no contra la descripcion que llevan las tarjetas. Varios codigos pueden
     * compartir descripcion (modalidades del mismo producto), asi que se agrupan en una sola
     * opcion que los manda todos y el desplegable sigue mostrando un unico seguro por nombre.
     */
    ExpedientesPageComponent.prototype.toOptions = function (items, etiquetaTodos) {
        var porEtiqueta = {};
        (items || []).forEach(function (i) {
            var id = (i && (null !== i.id) && (undefined !== i.id) ? i.id : '').toString().trim();
            if (!id) {
                return;
            }
            // Si la descripcion no viene resuelta se usa el propio codigo como etiqueta: queda
            // feo, pero peor seria dejar fuera del filtro expedientes que el usuario si ve.
            var label = ((i.itemName ? i.itemName : '').toString().trim()) || id;
            if (porEtiqueta[label]) {
                porEtiqueta[label].push(id);
            }
            else {
                porEtiqueta[label] = [id];
            }
        });
        var opts = [{ value: '', ids: [], label: etiquetaTodos }];
        Object.keys(porEtiqueta).sort().forEach(function (label) {
            var ids = porEtiqueta[label].sort();
            opts.push({ value: ids.join(','), ids: ids, label: label });
        });
        return opts;
    };
    ExpedientesPageComponent.prototype.estadoToSlug = function (raw) {
        var normalized = raw.toLowerCase();
        if (normalized.indexOf('curso') !== -1 || normalized.indexOf('tramit') !== -1) {
            return 'en-curso';
        }
        if (normalized.indexOf('cerrad') !== -1 || normalized.indexOf('finaliz') !== -1) {
            return 'cerrado';
        }
        return 'abierto';
    };
    ExpedientesPageComponent.prototype.estadoToLabel = function (slug, raw) {
        if (raw && raw.trim().length > 0) {
            return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
        }
        switch (slug) {
            case 'en-curso': return 'En curso';
            case 'cerrado': return 'Cerrado';
            default: return 'Abierto';
        }
    };
    ExpedientesPageComponent.prototype.formatDay = function (value) {
        if (!value) {
            return '';
        }
        var str = value.toString();
        var iso = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (iso) {
            return iso[3] + '/' + iso[2] + '/' + iso[1];
        }
        var date = new Date(str);
        if (isNaN(date.getTime())) {
            return str;
        }
        var pad = function (n) { return (n < 10 ? '0' + n : '' + n); };
        return pad(date.getDate()) + '/' + pad(date.getMonth() + 1) + '/' + date.getFullYear();
    };
    /**
     * Parametro de la URL con el que otras pantallas piden
     * el listado filtrado por una poliza: /expedientes?policy=<numero>.
     */
    ExpedientesPageComponent.POLICY_QUERY_PARAM = 'policy';
    return ExpedientesPageComponent;
}());
export { ExpedientesPageComponent };
